import { Stack } from '@mui/material';
import React from 'react';

import { EstimatedTimeOfArrivalFragment } from './EstimatedTimeOfArrivalFragment';
import { FaultSelectionsFormFragment } from './FaultSelectionsFormFragment';
import { FormInterceptorProps } from './FormInterceptor.props';
import { GetGeoLocationFormFragment } from './GetGeoLocationFormFragment';
import { GetParameterFormFragment } from './GetParameterFormFragment';
import { MerchantDamageTemplateFormFragment } from './MerchantDamageTemplateFormFragment';
import { ModifyStructureFormFragment } from './ModifyStructureFormFragment';
import { ParameterFormFragment } from './ParameterFormFragment';
import { ParameterNoUIFormFragment } from './ParameterNoUIFormFragment';
import { PartRequestFormFragment } from './PartRequestFormFragment';
import { ServiceCreationFormFragment } from './ServiceCreationFormFragment';
import { ServiceSearchFormFragment } from './ServiceSearchFormFragment';
import { SolutionActionFormFragment } from './SolutionActionFormFragment';
import { FormFieldType } from '../../../../../@types';
import { FormGenerator, SubformTypeNode } from '../../../../../components/templates/FormGenerator';

export const FormInterceptor: React.FC<FormInterceptorProps> = ({
  service,
  value,
  onChange,
  partActionData,
  onDamagedPartSelect,
  onAddForm,
  isRepeatable,
  forms,
  isMobileView
}) => {
  const subformTypeNodes: Array<SubformTypeNode> = [
    {
      service,
      formType: FormFieldType.FaultSelection,
      node: FaultSelectionsFormFragment
    },
    {
      service,
      formType: FormFieldType.SolutionAction,
      node: SolutionActionFormFragment
    },
    {
      service,
      formType: FormFieldType.PartsRequest,
      node: PartRequestFormFragment
    },
    {
      service,
      formType: FormFieldType.ServiceCreation,
      node: ServiceCreationFormFragment
    },
    {
      service,
      formType: FormFieldType.GetGeoLocation,
      node: GetGeoLocationFormFragment
    },
    {
      service,
      formType: FormFieldType.EstimatedTimeOfArrival,
      node: EstimatedTimeOfArrivalFragment
    },
    {
      service,
      formType: FormFieldType.ModifyStructure,
      node: ModifyStructureFormFragment
    },
    {
      service,
      formType: FormFieldType.SetParameter,
      node: ParameterFormFragment
    },
    {
      service,
      formType: FormFieldType.SetParameterNoUI,
      node: ParameterNoUIFormFragment
    },
    {
      service,
      formType: FormFieldType.MerchantDamageTemplate,
      node: MerchantDamageTemplateFormFragment
    },
    {
      service,
      formType: FormFieldType.GetParameter,
      node: GetParameterFormFragment
    },
    {
      service,
      formType: FormFieldType.ServiceSearch,
      node: ServiceSearchFormFragment
    }
  ];
  return (
    <Stack>
      <br/>
      <FormGenerator
        subformTypes={subformTypeNodes}
        value={value}
        onChange={(val) => onChange(val)}
        partActionData={partActionData}
        onDamagedPartSelect={
          (Objectkey: string, objectValue: FormData | number) => 
            onDamagedPartSelect(Objectkey, objectValue)
        }
        service={service}
        onAddForm={(templateId,templateTitle) => onAddForm && onAddForm(templateId,templateTitle)}
        isRepeatable={isRepeatable}
        forms={forms}
        isMobileView={isMobileView}
      />
    </Stack>
  );
};